import { render, staticRenderFns } from "./ListOfMeetingsYouAttend.vue?vue&type=template&id=6b15a45c"
import script from "./ListOfMeetingsYouAttend.vue?vue&type=script&lang=js"
export * from "./ListOfMeetingsYouAttend.vue?vue&type=script&lang=js"
import style0 from "./ListOfMeetingsYouAttend.vue?vue&type=style&index=0&id=6b15a45c&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports